export type ModuleId = 'tasks' | 'completed' | 'groceries' | 'stock' | 'meals' | 'fyp' | 'states' | 'goals' | 'voice';

export const DEFAULT_MODULE_ORDER: ModuleId[] = ['fyp', 'tasks', 'completed', 'groceries', 'stock', 'meals', 'states', 'goals', 'voice'];

import type { TagIconId, TagType } from '@/types/tag';
import type { TaskListSectionEntry } from '@/types/taskListLayout';

export type TagIconMap = Partial<Record<TagType, TagIconId>>;

export interface Team {
  id: string;
  name: string;
  slug: string | null;
  slogan: string | null;
  imageUrl: string | null;
  createdAt: Date;
  createdByUserId: string | null;
  // Weekend window settings (when weekly "weekend" tasks can be completed)
  weekendStartDay: number; // 0=Sun, 1=Mon, ..., 5=Fri, 6=Sat
  weekendStartHour: number; // 0-23
  weekendEndDay: number; // 0=Sun, 1=Mon, etc.
  weekendEndHour: number; // 0-23 (0 = midnight)
  // Team-wide time of day settings
  morningHour: number; // Default 6 = 06:00
  eveningHour: number; // Default 18 = 18:00
  // Module visibility settings
  showFypModule?: boolean; // Default false/true
  showTasksModule: boolean; // Default true
  showCompletedModule: boolean; // Default true
  showGroceryModule: boolean; // Default true
  showStockModule: boolean; // Default true
  showMealsModule?: boolean; // Default true
  showGoalsModule?: boolean; // Default false
  showVoiceModule?: boolean; // Default true
  moduleOrder: ModuleId[]; // Order of modules in navigation
  moduleLabels?: Partial<Record<ModuleId, string>>;
  tagIcons?: TagIconMap;
  language?: 'nl' | 'en';
  // Theme settings
  themePrimaryColor?: string;
  actionButtonBgColor?: string;
  actionButtonIconColor?: string;
  // Visibility
  isPublic?: boolean;
  // Invite code
  inviteCode?: string | null;
  inviteCodeEnabled?: boolean;
  /** Null = use DEFAULT_TASK_LIST_LAYOUT */
  taskListLayout?: TaskListSectionEntry[] | null;
}
